import { Banner, RadioButton, RadioGroup } from "@modernatx/ui-kit-react";
import React from "react";

import { PaymentMethodOptionRadioBtn } from "@/components/Payments/AutoPayModal/PaymentMethodOptionRadioBtn";
import { PaymentSelection } from "@/components/Payments/AutoPayModal/SchedulePayModal";
import { AddNewPaymentMethod, PaymentMethod } from "@/types/PaymentMethod";

interface PaymentMethodProps {
  allPaymentMethods: PaymentMethod[];
  defaultPaymentMethod: PaymentMethod | undefined;
  paymentMethodError?: string | null;
  selectedPayment?: PaymentSelection;
  setSelectedPayment?: React.Dispatch<React.SetStateAction<PaymentSelection>>;
}

const PaymentMethodCard: React.FC<PaymentMethodProps> = ({
  allPaymentMethods,
  defaultPaymentMethod,
  paymentMethodError,
  setSelectedPayment,
  selectedPayment
}) => {
  const selectedValue =
    selectedPayment === AddNewPaymentMethod
      ? AddNewPaymentMethod
      : (selectedPayment?.paymentMethodId ?? "");

  if (!selectedPayment) {
    return null;
  }

  const sortedPaymentMethods: PaymentMethod[] = defaultPaymentMethod
    ? [
        defaultPaymentMethod,
        ...allPaymentMethods.filter(
          (pm) =>
            pm.paymentMethodInfo.lastFour !==
            defaultPaymentMethod.paymentMethodInfo.lastFour
        )
      ]
    : [];

  const handleSelectionChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const value = event.target.value;
    const matchedMethod = allPaymentMethods.find(
      (pm) => pm.paymentMethodId === value
    );

    if (setSelectedPayment) {
      if (matchedMethod) {
        setSelectedPayment(matchedMethod);
      } else if (value === AddNewPaymentMethod) {
        setSelectedPayment(AddNewPaymentMethod);
      }
    }
  };

  return (
    <RadioGroup
      label="Using"
      value={selectedValue}
      onChange={handleSelectionChange}
    >
      {/* radio group is always expecting children to be ReactElement, might need fixing*/}
      {paymentMethodError ? (
        <Banner
          variant="critical"
          text="There was an error retrieving one or more of your saved payment methods."
        />
      ) : (
        <>
          {sortedPaymentMethods.map((pm) => (
            <PaymentMethodOptionRadioBtn
              key={pm.paymentMethodId}
              paymentMethod={pm}
              value={pm.paymentMethodId}
            />
          ))}
        </>
      )}

      <RadioButton
        key={AddNewPaymentMethod}
        label="Add a new payment method"
        value={AddNewPaymentMethod}
      />
    </RadioGroup>
  );
};

export default PaymentMethodCard;
